import React from "react"
import RPMCriticalCare from "./RPMCriticalCare"

const RPMCriticalPatientScreen = () => <RPMCriticalCare />

export default RPMCriticalPatientScreen
